import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AppConfigService } from './app-config.service';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpErrorResponse, HttpClient, HttpHeaders } from '@angular/common/http';
import { Response } from '../models/generated-view-models';
import { getErrorMessage, getWarningrMessage } from '../shared/utilities';
import { ResponseTypeEnum } from '../models/enums';
import { Globals } from '../shared/globals';

@Injectable({
    providedIn: 'root'
})
export class BaseHttpService {    

    public get headers(): HttpHeaders {
        return new HttpHeaders(
            {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem("Authorization"), 
                'Year': localStorage.getItem("Version") || ((new Date).getFullYear()).toString()
            }
        );
    }

    constructor(
        private http: HttpClient,
        private appConfig: AppConfigService,
        private router: Router,
        private globals: Globals) {
        
    }

    public Post = <TEntity>(url: string, entity: any, responseType: ResponseTypeEnum = 1): Observable<TEntity> => { 
        url = this.appConfig.settings.apiServerURL + url;
        return this.http.post<TEntity>(url, entity, {headers: this.headers})
        .pipe(map((res: Response<TEntity>) => {
            return this.getResponse(res, responseType);
        }), catchError(this.handleError)
        )
    };

    public Get = <TEntity>(url: string, responseType: ResponseTypeEnum = 1): Observable<TEntity> => {
        url = this.appConfig.settings.apiServerURL + url;
        return this.http.get<TEntity>(url, {headers: this.headers})
        .pipe(map((res: Response<TEntity>) => {
            return this.getResponse(res, responseType);
        }), catchError(this.handleError) 
        )
    };    

    public Delete = <TEntity>(url: string, responseType: ResponseTypeEnum = 1, params?: any): Observable<TEntity> => {
        url = this.appConfig.settings.apiServerURL + url;
        return this.http.delete<TEntity>(url, {headers: this.headers, params: params})
        .pipe(map((res: Response<TEntity>) => {
            return this.getResponse(res, responseType);
        }), catchError(this.handleError)
        )
    };

    private getResponse = <TEntity>(res: Response<TEntity>, responseType: ResponseTypeEnum) => {
        if (responseType == ResponseTypeEnum.Result || responseType == ResponseTypeEnum.Success) {
            if (!res.success) {
                this.handleUserFriendlyError(res.userFriendlyErrorMessage, res.errorMessages);
            } else if (res.success && res.userFriendlyWarningMessage) {
                getWarningrMessage(res.userFriendlyWarningMessage);
            }
            return responseType == ResponseTypeEnum.Result ? res.result : res.success;
        } else {
            return res;
        }
    }

    private handleError = (err: HttpErrorResponse): Observable<any> => {
        if (err.status === 401) {                
            //auto logout if 401 response returned from api
            this.globals.isLoogedIn = false;
            localStorage.removeItem('Authorization');             
            this.router.navigate(['login']);
        } else {
            getErrorMessage();
        }        
        return throwError(err);
    }

    private handleUserFriendlyError = (userFriendlyError: string, backendError: any): void => {
        if (userFriendlyError) {
            getErrorMessage(userFriendlyError);
            console.error('User Friendly Error Message - ', userFriendlyError || 'Unknown Error');
        } else {
            getErrorMessage();
            console.error('Backend Error Message - ', backendError || 'Unknown Error');
        }                      
    }

    buildParamsFromList = (ids: number[], paramName: string): string => {
        let params: string[] = [];
        ids.forEach((id: number) => {
            params.push(`${paramName}=${id}`);
        });

        return params.join('&');
    }

    public getFile = (url: string, callback: Function = null): void => {
        var client = new XMLHttpRequest();
        client.open('GET', url, true);
        client.setRequestHeader('Content-Type', 'application/json; charset=utf-8');
        client.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem("Authorization"));
        client.setRequestHeader('Year', localStorage.getItem("Version") || ((new Date).getFullYear()).toString());
        client.responseType = 'blob';

        client.onload = function (e) {
            if (client.status === 200) {
                // Try to find out the filename from the content disposition `filename` value
                var filename = "";
                var disposition = client.getResponseHeader('Content-Disposition');
                if (disposition && disposition.indexOf('filename') !== -1) {
                    var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    var matches = filenameRegex.exec(disposition);
                    if (matches != null && matches[1]) {
                        filename = matches[1].replace(/['"]/g, '');
                    }
                }

                var contentType = client.getResponseHeader('Content-Type');
                // The actual download
                var blob = new Blob([client.response], { type: contentType });
                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                if(callback){
                    callback();
                }
            }
        };
        client.send();
    }
}
